/** An eager native dialog: recovery must not depend on another lazy component. */
export function confirmPageReload(message: string, reloadLabel: string, cancelLabel: string): Promise<boolean> {
  return new Promise((resolve) => {
    const dialog = document.createElement('dialog')
    dialog.className = 'modal'
    const box = document.createElement('div')
    box.className = 'modal-box'
    const description = document.createElement('p')
    description.id = 'chunk-recovery-description'
    description.textContent = message
    dialog.setAttribute('aria-labelledby', description.id)
    const actions = document.createElement('div')
    actions.className = 'modal-action'
    const cancel = document.createElement('button')
    cancel.className = 'btn'
    cancel.textContent = cancelLabel
    const reload = document.createElement('button')
    reload.className = 'btn btn-primary'
    reload.textContent = reloadLabel
    const finish = (accepted: boolean) => {
      dialog.close()
      dialog.remove()
      resolve(accepted)
    }
    cancel.addEventListener('click', () => finish(false))
    reload.addEventListener('click', () => finish(true))
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault()
      finish(false)
    })
    actions.append(cancel, reload)
    box.append(description, actions)
    dialog.append(box)
    document.body.append(dialog)
    dialog.showModal()
    cancel.focus()
  })
}
